/* ==========================================================================
   GOODS SCENE -- PDP PAYMENT / SHIPPING / RETURN: DISCLOSURE STATE ONLY

   🛑 THIS SCRIPT EXISTS BECAUSE <details>/<summary> CANNOT PRODUCE THE APPROVED
   LAYOUT. A panel inside <details> is a descendant of its own control, so it
   cannot also be a sibling grid item spanning every column on the row below.
   Flat button + panel siblings can. That is the ONLY reason there is JavaScript
   here -- no animation, no library, no DOM rewriting, no content cloning.

   🔑 THE SERVER SHIPS THE OPEN, READABLE STATE. Every panel arrives visible and
   every control arrives disabled with aria-expanded="true", which is exactly
   what is on screen. This script is what CLOSES things, and it also flips
   data-enhanced, which is what switches the CSS into the three-column layout.

   🛑 ENHANCEMENT IS ALL-OR-NOTHING. Every control must resolve to a unique
   panel inside this element before anything is touched. A component that fails
   validation is left exactly as the server sent it: panels visible, controls
   disabled, single readable column. A half-wired card would hide legal copy
   behind a control that cannot reopen it.
   ========================================================================== */

(function () {
  if (customElements.get('gs-pdp-psr')) return;

  class GsPdpPsr extends HTMLElement {
    connectedCallback() {
      /* The Theme Editor re-renders the whole section, so a fresh element with
         fresh server markup arrives and initialises once. */
      if (this.dataset.enhanced === 'true') return;

      var pairs;
      try {
        pairs = this.validate();
      } catch (e) {
        if (window.console) console.warn('[gs-pdp-psr] enhancement skipped:', e);
        return;
      }

      if (!pairs) return;

      this.pairs = pairs;

      var self = this;
      pairs.forEach(function (pair) {
        /* 🛑 ORDER MATTERS. Hide, then correct aria-expanded, then hand the
           control to the user -- the markup never claims a state that is not
           on screen. */
        pair.panel.hidden = true;
        pair.ctrl.setAttribute('aria-expanded', 'false');
        pair.ctrl.disabled = false;
        pair.ctrl.addEventListener('click', function () {
          self.toggle(pair);
        });
      });

      /* 🔑 LAST. Only now does the CSS switch to the interactive layout, so the
         three-column grid never applies to a card whose panels are all still
         visible. */
      this.dataset.enhanced = 'true';
    }

    /* Returns the pair list only if EVERY control resolves to its own unique
       panel inside this element. Returns null otherwise -- and null means the
       whole component stays unenhanced. */
    validate() {
      var ctrls = this.querySelectorAll('.gs-psr__ctrl');
      if (!ctrls.length) return null;

      var pairs = [];
      var seen = [];

      for (var i = 0; i < ctrls.length; i++) {
        var ctrl = ctrls[i];

        var id = ctrl.getAttribute('aria-controls');
        if (!id) return null;

        var panel = document.getElementById(id);
        if (!panel) return null;
        if (!this.contains(panel)) return null;
        if (seen.indexOf(panel) !== -1) return null;

        seen.push(panel);
        pairs.push({ ctrl: ctrl, panel: panel });
      }

      return pairs;
    }

    /* One panel open at a time: opening any item closes whichever was open, and
       pressing the open item closes it, leaving all three closed. */
    toggle(target) {
      var isOpen = target.ctrl.getAttribute('aria-expanded') === 'true';

      this.pairs.forEach(function (pair) {
        var shouldOpen = pair === target && !isOpen;
        pair.panel.hidden = !shouldOpen;
        pair.ctrl.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      });

      /* ⚠️ Focus is deliberately not moved. The control the user pressed keeps
         focus, which is what a native disclosure does. */
    }
  }

  customElements.define('gs-pdp-psr', GsPdpPsr);
})();
